import URL_ROUTE from "../constants/index.js";
import request from "../configs/AxiosWrapper.js";

let token = sessionStorage.getItem('token');

const UsuarioService = () => {
    const listarUsuarios = async () => {
        if (!token) return;
        return await request(URL_ROUTE.LISTARUSUARIOS, {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${token}` }
        });
    };

    const updateUsuarios = async (data) => {
        return await request(URL_ROUTE.UPDATEUSUARIOS, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });
    };

    const crearUsuarios = async (data) => {
        return await request(URL_ROUTE.CREATEUSUARIOS, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });
    };

    const saberSiEstaOcupado = async (data) => {
        return await request(URL_ROUTE.SABERSIESTAOCUPADO, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });
    };

    const createUserMasivo = async (data) => {
        return await request(URL_ROUTE.CREATEUSERMASIVO, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });
    };
/* ID_PLANTA */
    const getUsuariosForPlanta = async (data) => {
        return await request(URL_ROUTE.GETFORPLANTAUSUARIOSOLOPLANTA, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });
    };

    return {
        listarUsuarios,
        updateUsuarios,
        crearUsuarios,
        saberSiEstaOcupado,
        createUserMasivo,
        getUsuariosForPlanta
    };
};

export default UsuarioService;
